module.exports = __webpack_public_path__ + "static/img/xianggang.65e656f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/xianggang.png
// module id = 38p4
// module chunks = 1